import type {
  BillingInvoice,
  BillingInvoiceApiRecord,
  BillingInvoicesApiResponse,
} from 'types/billingInvoice';

import { axiosInstance as axios } from './index';

export const mapBillingInvoiceFromApi = (
  record: BillingInvoiceApiRecord,
): BillingInvoice => ({
  id: record.id,
  number: record.number ?? null,
  status: record.status,
  amount: record.amount,
  currency: record.currency,
  issuedAt: record.issued_at,
  dueAt: record.due_at ?? null,
  stripePdfUrl: record.stripe_pdf_url ?? null,
  s3PdfUrl: record.s3_pdf_url ?? null,
});

const normalizeInvoicesResponse = (
  payload: BillingInvoicesApiResponse,
): BillingInvoiceApiRecord[] => {
  if (Array.isArray(payload)) return payload;
  return payload.invoices ?? [];
};

export const INVOICES_PER_PAGE = 5;

export async function fetchBillingInvoices(): Promise<BillingInvoice[]> {
  const response = await axios.get<BillingInvoicesApiResponse>(
    'billing/invoices',
  );
  const records = normalizeInvoicesResponse(response.data);
  return records
    .map(mapBillingInvoiceFromApi)
    .sort(
      (a, b) => new Date(b.issuedAt).getTime() - new Date(a.issuedAt).getTime(),
    );
}
